import app from "./app.js";
import stores from "./stores/index.js";
import {configure} from "mobx";

// This is recommended by mobx as a kind of "strict mode"
configure({
	enforceActions:             "always",
	computedRequiresReaction:   true,
	reactionRequiresObservable: true,
	// observableRequiresReaction: true, // TODO: remove (see next line)
	observableRequiresReaction: false, // We need this for some API calls (e.g. `getProject` returns a project "outside a reactive context")
	disableErrorBoundaries:     true
});

export default Object.assign({app}, stores);
